export enum ProductsRidersPolicyType {
  CriticalIllness,
  Cancer,
  Disability,
  Shop,
  Icrtn,
  Iwl,
  HeartStroke,
  Accident,
  UniversalLife,
  GLTerm,
  PinCare,
  AccidentNewYork,
  Gwl,
  CriticalIllnessNY,
  DitWuNY,
  Aip,
  Gvcip4,
  TermLife,
  DisabilityNC,
}

export const ProductRiderGroups = new Map();
ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness] = 'CRITICAL ILLNESS';
ProductRiderGroups[ProductsRidersPolicyType.Cancer] = 'CANCER';
ProductRiderGroups[ProductsRidersPolicyType.Disability] = 'DISABILITY';
ProductRiderGroups[ProductsRidersPolicyType.Shop] = 'SHOP';
ProductRiderGroups[ProductsRidersPolicyType.Icrtn] = 'ICRTN';
ProductRiderGroups[ProductsRidersPolicyType.Iwl] = 'IWL';
ProductRiderGroups[ProductsRidersPolicyType.HeartStroke] = 'HEART STROKE';
ProductRiderGroups[ProductsRidersPolicyType.Accident] = 'ACCIDENT';
ProductRiderGroups[ProductsRidersPolicyType.UniversalLife] = 'UNIVERSAL LIFE';
ProductRiderGroups[ProductsRidersPolicyType.GLTerm] = 'GLTERM';
ProductRiderGroups[ProductsRidersPolicyType.PinCare] = 'PINCARE';
ProductRiderGroups[ProductsRidersPolicyType.AccidentNewYork] = 'ACCIDENTNY';
ProductRiderGroups[ProductsRidersPolicyType.Gwl] = 'GWL';
ProductRiderGroups[ProductsRidersPolicyType.CriticalIllnessNY] = 'CRITICAL ILLNESS NY';
ProductRiderGroups[ProductsRidersPolicyType.DitWuNY] = 'DITWUNY';
ProductRiderGroups[ProductsRidersPolicyType.Aip] = 'AIP';
ProductRiderGroups[ProductsRidersPolicyType.Gvcip4] = 'GVCIP4';
ProductRiderGroups[ProductsRidersPolicyType.DisabilityNC] = 'DISABILITY NC';
ProductRiderGroups[ProductsRidersPolicyType.TermLife] = 'TERM LIFE';

export const ProductMapping = new Map();

ProductMapping[1] = ProductRiderGroups[ProductsRidersPolicyType.Disability];
ProductMapping[2] = ProductRiderGroups[ProductsRidersPolicyType.Cancer];
ProductMapping[4] = ProductRiderGroups[ProductsRidersPolicyType.Accident];
ProductMapping[5] = ProductRiderGroups[ProductsRidersPolicyType.Shop];
ProductMapping[6] = ProductRiderGroups[ProductsRidersPolicyType.HeartStroke];
ProductMapping[7] = ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness];
ProductMapping['U'] = ProductRiderGroups[ProductsRidersPolicyType.UniversalLife];
ProductMapping['A'] = ProductRiderGroups[ProductsRidersPolicyType.Aip];
